module.exports = __webpack_public_path__ + "img/time-off-night.36dbb486.png";